import React, { FC } from 'react';

const cancelStyle = {
  backgroundColor: '#019ada',
  borderRadius: '16px',
  color: 'white',
  cursor: 'pointer',
  lineHeight: '32px',
  padding: '0 5px',
  margin: '5px 5px',
  minWidth: '115px',
  'text-align': 'center',
  'white-space': 'nowrap',
};

interface CancelButtonProps {
  haveKey: boolean;
  display: boolean;
  cancel: () => void;
}

const CobrowseCancelButton: FC<CancelButtonProps> = (
  cancelButtonProps: CancelButtonProps
) => {
  const { haveKey, display, cancel } = cancelButtonProps;

  return (
    display && (
      <div style={cancelStyle} onClick={cancel}>
        {haveKey ? 'Cancel' : 'Have key?'}
      </div>
    )
  );
};

export default CobrowseCancelButton;
